module.exports = __webpack_public_path__ + "static/fonts/NotoSansCJKkr-Thin.3787dd4.ttf";